
// This script creates an iframe in host site setting the src as widget html which has the widget content
class Gidget {
  constructor() {
  }
    init({shopId, buttonId = 'ziza-button', logoUrl = "https://bookfor.xyz/wp-content/uploads/2024/05/dining-room-logo.png" ,shopName, demo = false}) {
             // When the DOM is ready
      document.addEventListener('DOMContentLoaded', function () {
        // Get the button element
        const buttons = document.getElementsByClassName(buttonId);

        // add styles
        const styles = document.createElement('style');
        styles.innerText = `
        /* The Modal (background) */
        .bookforxyz-modal {
        /* display: none; Hidden by default */
        position: fixed; 
        /* Stay in place */
        z-index: 999; 
        /* Sit on top */
        left: 0;
        top: 12%;
        width: 100%;
        /* Full width */
        height: 80%;
        /* Full height */
        overflow: auto; 
        /* Enable scroll if needed */
        }

        /* Modal Content/Box */
        .bookforxyz-modal-content { 
        position: relative;
        background-color: #fefefe;
        margin: 0 auto; 
        max-width: 482px;
        height: 100%;
        }

        .close {
        z-index: 999;
        cursor: pointer;
        position: absolute;
        font-size: 28px;
        font-weight: bold;
        right: 24px;
        top: -10px;
        width: 40px;
        line-height: 44px;
        text-align: right;
        background-color: transparent;
        border: 0px;
        }

        .close:hover,.close:focus {
        color: #023047;
        text-decoration: none;
        cursor: pointer;
        }
        `
    const modalhost = document.querySelector('#bookfor-xyz-script')
    modalhost.appendChild(styles);


        // When the button is clicked
        for (var i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener('click', function () {
          // Create the modal element
          const modal = document.createElement('div');
          modal.classList.add('bookforxyz-modal');
 

          // Create the modal content element
          const modalContent = document.createElement('div');
          modalContent.classList.add('bookforxyz-modal-content');
          
          // Create the close button element
          const closeButton = document.createElement('span');
          closeButton.classList.add('close');
        
      closeButton.innerHTML = '&times;'

          // Create the iframe element
          const iframe = document.createElement('iframe');
          const widgetUrl = demo ? process.env.WIDGET_DEMO_URL : process.env.WIDGET_URL;
          iframe.setAttribute('src', `${widgetUrl}?shopId=${shopId}&logo=${logoUrl}&shopName=${shopName}`);
          iframe.setAttribute('frameborder', '0');
          iframe.style.position = 'absolute';
          iframe.style.left = '0';
          iframe.style.top = '0';
          iframe.style.height = '80vh';
          iframe.style.width = '100%';
          // iframe.style.background = '#E0B0FF';
          iframe.style.overflow = 'clip';
          iframe.style.background = '#eef2f6'


          // Add the close button and iframe to the modal content
          modal.appendChild(closeButton);
          modalContent.appendChild(iframe);

          // Add the modal content to the modal
          modal.appendChild(modalContent);

          // Add the modal to the page
          document.body.appendChild(modal);

          // When the user clicks the close button
          closeButton.addEventListener('click', function () {
            // Remove the modal from the page
            document.body.removeChild(modal);
            button.style.display = 'initial'
          });

          // When the user clicks outside the modal
          window.addEventListener('click', function (event) {
            if (event.target == modal) {
              // Remove the modal from the page
              document.body.removeChild(modal);
              
            }
          });
          // button.style.display = 'none' why did I do this??
        });
      }
      });
    
    }
}


function initiliazeWidget() {
    this.Gidget = new Gidget();
}
initiliazeWidget.call();